/**
 * ネイティブアプリで共有シート（「BluePaperで開く」）から受け取った
 * 音声ファイルを、受信ハンドラ → 新規作成ページへ受け渡すための一時ストア。
 */
let pendingSharedAudio: File | null = null

export function setPendingSharedAudio(file: File) {
  pendingSharedAudio = file
}

/** 取り出すと同時にクリアされる（1回限り） */
export function consumePendingSharedAudio(): File | null {
  const file = pendingSharedAudio
  pendingSharedAudio = null
  return file
}
